import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setRegPage, currentWidget, setLoadingMass, popupOpenClose } from '../../../../action/action'
import AcControl from './acControl'
import RoomTheme from "./RoomTheme"
import { setLoginRequired } from '../../../action/homeAction'
import { wipeGuestData } from '../../../../JS/wipeGuestData'
import { guestDetails } from '../../../../action/homeAction'
import { setRoomControlPage } from '../../../action/action'
import MultiController from './MultiController'
import { DEMO } from '../../../../config/constant'
import { getVDARoomControlData } from '../../../../action/roomControlAction'

class VDARoomControl extends Component {
    constructor(props) {
        super(props);
        this.time = 0;
        this.state = {
            loadingMass: false,
        }
    }

    componentDidMount() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        console.log('this.props.guestDetail',this.props.guestDetail)
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            if (this.props.currentWidgets.widgetType && !room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } else {
                    this.props.setRegPage(true);
                }
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        } else {
            this.callStatusAPI(SessionToken);
        }
        this.props.guestDetails(SessionToken, wipeGuestData, this.props.guestDetail.guestToken);
    }

    callStatusAPI = (SessionToken) => {
        this.time = window.setTimeout(() => {
            if (this.state.loadingMass) {
                this.props.setLoadingMass(false);
                this.setState({ loadingMass: false });
            }
        }, 3000);
        this.props.setLoadingMass(true);
        this.setState({ loadingMass: true });
        this.props.getVDARoomControlData( this.props.guestDetail, this.VDAStatusCallBack, this);
    }

    componentWillUnmount() {
        this.props.currentWidget({});
    }

    VDAStatusCallBack(status, msg, thisRef) {
        if (thisRef.state.loadingMass) {
            thisRef.props.setLoadingMass(false);
            window.clearTimeout(thisRef.time);
            thisRef.setState({ loadingMass: false });
            if (!status && !DEMO) {
                console.log('roomControl2');
                thisRef.props.popupOpenClose(true, "Network Error.");
            } else {
                console.log("VDA roomControl api sucess")
            }
        }
        
    }

    getCurrentPage = () => {
        
        switch (this.props.currentPage) {
            case "Multi-Controller":
                return <MultiController/>;
            case 'AcControl':
                return (<AcControl />)
            case 'roomTheme':
                return (<RoomTheme />) 
        }
    }

    render() {
        return (
            <div class="main-container">
                {this.getCurrentPage()}
                {console.log('this.props.hvac',this.props.hvac)}
                {console.log('this.props.lightScene',this.props.lightScene)}
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store2.roomControl.currentPage,
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        hvac: state.store.VDARoomControl.hvac,
        lightScene: state.store.VDARoomControl.lightScene,
        menuColor: state.store.home.MenuColor,
    }
}
export default connect(
    mapStateToProps,
    {
        getVDARoomControlData,
        setRegPage,
        currentWidget,
        setLoadingMass,
        popupOpenClose,
        setLoginRequired,
        guestDetails,
        setRoomControlPage
    }
)(VDARoomControl);